import * as Yup from "yup"

export const OtpSchema = Yup.object().shape({
    otp1: Yup.string()
    .test('is-number', 'OTP1 must be a number', (value) => /^[0-9]+$/.test(value))
    .required('OTP is required'),
  otp2: Yup.string()
    .test('is-number', 'OTP2 must be a number', (value) => /^[0-9]+$/.test(value))
    .required('OTP is required'),
  otp3: Yup.string()
    .test('is-number', 'OTP3 must be a number', (value) => /^[0-9]+$/.test(value))
    .required('OTP is required'),
  otp4: Yup.string()
    .test('is-number', 'OTP4 must be a number', (value) => /^[0-9]+$/.test(value))
    .required('OTP is required'),
    otp5: Yup.string()
    .test('is-number', 'OTP5 must be a number', (value) => /^[0-9]+$/.test(value))
    .required('OTP is required'),
    otp6: Yup.string()
    .test('is-number', 'OTP6 must be a number', (value) => /^[0-9]+$/.test(value))
    .required('OTP is required'),

  });